const navigationMobile = document.querySelector(".navigation");

if (navigationMobile) {
   const body = document.body;
   const btnMenu = document.querySelector(".navigation-toggle");
   const btnClose = document.querySelector(".navigation-close");
   const overlay = document.querySelector(".navigation-overlay");

   // Null-Guard: Script nur ausführen wenn alle erforderlichen Elemente vorhanden sind
   if (!btnMenu || !btnClose || !overlay) {
      console.warn("navigation-mobile.js: Erforderliche DOM-Elemente fehlen (.navigation-toggle, .navigation-close oder .navigation-overlay).");
   } else {

      //Menu Hamburger
      const menuToggleOpen = () => {
         setTimeout(() => {
            body.style.overflow = "hidden";
            btnMenu.setAttribute("aria-expanded", "true");
            navigationMobile.classList.add("show");
            navigationMobile.removeAttribute("inert");
            overlay.classList.add("show");
         }, 1);
      };

      const menuToggleClose = () => {
         setTimeout(() => {
            body.removeAttribute("style");
            btnMenu.setAttribute("aria-expanded", "false");
            navigationMobile.classList.remove("show");
            navigationMobile.setAttribute("inert", "");
            overlay.classList.remove("show");
         }, 1);
      };

      btnMenu.addEventListener('click', () => {
         if (btnMenu.getAttribute("aria-expanded") === "false") {
            menuToggleOpen();
         } else {
            menuToggleClose();
         }
      });

      btnClose.addEventListener('click', () => {
         menuToggleClose();
      });

      // Fix: Overlay-Event-Listener nur einmal registrieren (war zuvor doppelt)
      overlay.addEventListener('click', () => {
         menuToggleClose();
      });

      // Navigation mit Escape-Taste schließen
      document.addEventListener('keydown', (event) => {
         if (event.code === 'Escape' && btnMenu.getAttribute("aria-expanded") === "true") {
            menuToggleClose();
            btnMenu.focus();
         }
      });
   }
}
